<template>
    <FormSection title="Pharmacy Information" :full-height="false" :application-id="application">
        <template #content>
            <section class="row my-2 col-12 px-5 row g-0">
                <section class="col-12 row">
                    <div class="form-group col-12 mb-0">
                        <section>
                            <label>
                                Pharmacy:
                                <a
                                    tabindex="0"
                                    role="button"
                                    v-custom-popover="{ content: sanitizeMarkup(attendingPharmacyTooltip) }"
                                >
                                    <i class="fas fa-question-circle text-dark font-size-xs"></i>
                                </a>
                            </label>
                            <TypeaheadInput
                                :getData="getPharmacyList"
                                :value="attendingPharmacy"
                                v-on:valueChanged="attendingPharmacyChanged"
                                :init-value="attendingPharmacy"
                                placeholder="Begin typing the pharmacy name"
                            />
                            <button class="btn btn-xs btn-primary m-2" @click="newPharmacy()">New Pharmacy</button>
                        </section>
                    </div>
                </section>
            </section>
        </template>
    </FormSection>

    <FormSection title="Additional Pharmacy" :full-height="false" :application-id="application" class="mt-2">
        <template #content>
            <section class="row my-2 col-12 px-5 row g-0">
                <section class="col-12 row">
                    <div class="form-group col-12">
                        <div class="form-group col-12 ps-0">
                            <div v-for="(contact, index) in additionalPharmacy" :key="index">
                                <div class="col-12 px-0">
                                    <div class="d-flex align-items-center">
                                        <p class="mb-1">Additional Pharmacy {{ index + 1 }}</p>
                                        <button
                                            class="btn table-btn btn-outline-danger me-1 ms-auto"
                                            @click="removePharmacyContact(index)"
                                        >
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="form-group mt-0">
                                    <label> Pharmacy: </label>
                                    <TypeaheadInput
                                        :getData="getPharmacyList"
                                        :value="contact.Name"
                                        v-on:valueChanged="(e:any) => additonalPharmacyChanged(e, index)"
                                        :init-value="null"
                                        placeholder="Begin typing the pharmacy name"
                                    />
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-xs btn-primary m-0" @click="addPharmacy()">Add Pharmacy</button>
                    </div>
                </section>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./ReferralPharmacy.ts"></script>
